const environment = window._env_ || {};
export default environment;